module.exports = __webpack_public_path__ + "img/icons.785b1fe0.svg";